export default function generateLink (path) {
  try {
    const url = new URL(path);
    return url.href;
  } catch {
    const currentHost = window.location.origin;
    return `${currentHost}/${path.replace(/^\//, '')}`;
  }
}
